import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslocoService} from '@ngneat/transloco';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe extends DatePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
    super(translocoService.getActiveLang());
  }

  override transform(value: any, format = 'short'): any {
    const lang: string = this.translocoService.getActiveLang() === 'en' ? 'en-GB' : this.translocoService.getActiveLang();
    return super.transform(value, format, undefined, lang);
  }
}
